export default {
      id: "oc-menu-suggest-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-suggest",
      toString: function () {
        return this.url;
      }
    }